/**
 * @generated SignedSource<<04f89a32707be7e3004087c9a657c42f>>
 * @relayHash 12bbce6123968e096388387177641cd4
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 60f72e1175cf5551d23278069fec99e60d9b9f4ef394b567a41280b175fedf57

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { ui_jiraCalendarQuery } from './ui_jiraCalendarQuery.graphql';

const node: PreloadableConcreteRequest<ui_jiraCalendarQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "60f72e1175cf5551d23278069fec99e60d9b9f4ef394b567a41280b175fedf57",
    "metadata": {},
    "name": "ui_jiraCalendarQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
